import React from 'react';
import {withStyles, createStyles} from '@material-ui/core/styles';
import {Button, Theme} from '@material-ui/core';

const styles = (theme: Theme) =>
    createStyles({
        root: {
            backgroundColor: theme.palette.secondary.dark,
            textTransform: 'none',
        },
    });

const StyledSyncButton = withStyles(styles)(Button);
export default StyledSyncButton;
